import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import GridItem from 'src/components/grid-item/GridItem'
import { PersonReportItem } from 'src/modules/motor-credito/serasa/serasa.experian.person.types'
import { formatDateNoTz } from 'src/utils/formatter-utils'

export type IdentificacaoProps = {
    person: PersonReportItem
}

export default function Identificacao({ person }: IdentificacaoProps) {
    return (
        <>
            <Divider textAlign="center">Identificação</Divider>

            <Grid
                container
                spacing={1}
                sx={{
                    paddingTop: 2,
                    paddingBottom: 2,
                    paddingLeft: 5,
                    paddingRight: 5
                }}
            >
                <GridItem label="Titular" value={person.registration.consumerName} xs={8} />

                <GridItem label="Nome da Mãe" value={person.registration.motherName || '-'} xs={4} />
                <GridItem label="Sexo" value={person.registration.consumerGender} xs={4} />

                <GridItem label="Estado Civil" value={person.registration.maritalStatusDescription || '-'} xs={8} />

                <GridItem label="Situação Data" value={formatDateNoTz(person.registration.statusDate)} xs={4} />
                <GridItem label="Situação Status" value={person.registration.statusRegistration} xs={8} />
            </Grid>

            <GridItem label="Data Nascimento" value={formatDateNoTz(person.registration.birthDate)} xs={4} />
        </>
    )
}
